module.exports = __webpack_public_path__ + "img/9788936456443.b5861bcd.jpg";